/**
 * Module to load requirejs config if exists in window.requireconfig
 */
(function() {
    'use strict';
    if (window.requireConfig) {
        //  setting requirejs config
        requirejs.config(window.requireConfig);
        delete window.requireConfig;
    }
}());

define('main',['durandal/system','./index'], function(system) {
    'use strict';
    //system.debug(true);
    console.log('app should start now');
});

